import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'ROLES'

export type RolesState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function rolesReducer(state: RolesState = initialState, action: AnyAction): RolesState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
